import React from 'react';

const SvgActions12 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 16 20" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M16 19a1 1 0 0 1-1.53.85l-5.94-3.72a1 1 0 0 0-1.06 0l-5.94 3.72A1 1 0 0 1 0 19V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgActions12 svgRef={ref} {...props} />);
export default ForwardRef;
